import { Box, Flex, Space } from '@mantine/core';
import { useParams } from '@tanstack/react-router';

import { ClubInteractionContainer } from '@/features/work-interactions/containers/ClubInteractionContainer';
import { translate } from '@/shared/i18n/translate';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

export const ArtistWorkInviteInfoPage = () => {
  const { id: artistId, workInviteId } = useParams({
    from: '/artist/$id/work-invite/$workInviteId'
  });

  return (
    <Box>
      <Flex align='center' justify='space-between'>
        <LBBackButton />
        <LBLinkButton>{translate('commons.help')}</LBLinkButton>
      </Flex>
      <Space h={16} />
      <ClubInteractionContainer artistId={artistId} workItemId={workInviteId} />
      <Space h={150} />
    </Box>
  );
};
